const AdminTable = ({ admins }) => {
    return ( 
        <table className="mt-4">
            <thead>
                <tr>
                    <th>Name</th>
                    <th className="hide-on-small-only">Email</th>
                    <th className="hide-on-small-only">Gender</th>
                    <th className="hide-on-small-only">ID No.</th>
                </tr>
                </thead>
                <tbody>    
                    {
                        admins && admins  !== 0 && admins.map(admin => (
                            <tr key={admin.idNumber}>
                                <td>{admin.title} {admin.forenames} {admin.surname}</td>
                                <td className="hide-on-small-only">{admin.email}</td>    
                                <td className="hide-on-small-only">{admin.gender}</td>    
                                <td className="hide-on-small-only">{admin.idNumber}</td>    
                            </tr>
                        ))
                    }         
            </tbody>
        </table>
     );
}
 
export default AdminTable;